import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllHotels = async () => {
  try {
    const { data } = await AxiosInstance.get("/hotels");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Create Destination
export const createHotels = async (hotel) => {
  try {
    const { data } = await AxiosInstance.post("/hotels", hotel);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Update Destination
export const updateHotels = async (hotel) => {
  try {
    const { data } = await AxiosInstance.put("/hotels", hotel);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Delete Destination
export const deleteHotels = async (hotel) => {
  try {
    const { data } = await AxiosInstance.delete(`/hotels/${hotel._id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
